import { gql } from '@apollo/client'

export const SUBSCRIBE_NOTIFICATION = gql`
  mutation SubscribeToNotification($input: subscribeToNotificationInput) {
    subscribeToNotification(input: $input) {
      sMessage
    }
  }
`
